export default __webpack_public_path__ + "static/intro-91d62caba0d24853e2502703431322ea.gif";